import {
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
  Tooltip,
  Stack,
  Typography,
  useMediaQuery,
  Menu,
  MenuItem,
  ListItemIcon,
  Dialog,
  DialogContent,
  Divider,
  Slide,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { BiTrash, BiEdit } from "react-icons/bi";
import { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationDialog from "../../../../helpers/ConfirmationDialog";
import { MdOutlineClear } from "react-icons/md";
import dayjs from "dayjs";
import DateRangepicker from "../../../../helpers/dateRangePicker";
import { Xray, setSearchBody } from "../../../../app/slices/xraySlice";
import { SelectXrayType } from "../../../../components/Selectors/SelectXray";
import { useTheme } from "@emotion/react";
import { HiMenu } from "react-icons/hi";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const XrayTable = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("lg"));

  const _Role = useSelector((state) => state.user.userInfo.role);
  const _Xray = useSelector((state) => state.xray.xrayData);
  const _SearchBody = useSelector((state) => state.xray.searchBody);
  const loading = useSelector((state) => state.xray.loading);
  const _XrayType = useSelector((state) => state.xray.xrayTypeData);

  const [search, setSearch] = useState({
    name: "",
    xray_type_id: null,
    start_date: dayjs().format("YYYY-MM-DD"),
    end_date: dayjs().format("YYYY-MM-DD"),
  });
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [openConfirm, setConfirmOpen] = useState(false);
  const [dialogData, setDialogData] = useState("");
  const [activeItem, setActiveItem] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const handleMenuClick = (event, item) => {
    setOpenMenu(event.currentTarget);
    setActiveItem(item);
  };

  const handleClose = () => {
    setActiveItem(null);
    setOpenMenu(null);
  };

  const handleDeleteClick = (params) => {
    setConfirmOpen(true);
    setDialogData(params);
  };

  const handleConfirmDelete = () => {
    dispatch(Xray.deleteById(dialogData.id, _SearchBody));
    setConfirmOpen(false);
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
  };
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [imageDialogData, setImageDialogData] = useState("");

  const handleCellClick = (params) => {
    if (params.field === "attachment") {
      if (params.row.attachment) {
        setImageDialogData(params.row.attachment);
        setOpenImageDialog(true);
      }
    }
  };

  var columns = [
    {
      field: "id",
      headerName: "رقم الاشعة",
      flex: 0.7,
    },
    {
      field: "patient_name",
      headerName: "اسم المراجع",
      flex: 1,
    },
    {
      field: "xray_type_name",
      headerName: "نوع الاشعة",
      flex: 0.7,
    },
    {
      field: "price",
      headerName: "السعر",
      flex: 0.7,
      renderCell: (params) => params.row.price?.toLocaleString(),
    },
    {
      field: "user_name",
      headerName: "اسم الطبيب",
      flex: 1,
    },
    {
      field: "date",
      headerName: "التاريخ",
      flex: 1,
      renderCell: (params) => (
        <Stack direction="column">
          <Typography>{dayjs(params.row.date).format("YYYY-MM-DD")}</Typography>
          <Typography variant="caption">
            {dayjs(params.row.date).format("hh:mm: a")}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "attachment",
      headerName: "الصورة",
      width: 160,
      renderCell: (params) => (
        <Box
          component="img"
          src={params.row.attachment}
          sx={{ width: "100%" }}
        />
      ),
    },
    {
      field: "operations",
      headerName: "العمليات",
      flex: matchUpMd ? 1 : 0.7,
      renderCell: (params) => {
        return matchUpMd ? (
          <>
            <Tooltip title="تعديل">
              <IconButton
                color="primary"
                onClick={() => dispatch(Xray.getById(params.row.id))}
              >
                <BiEdit />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                color="error"
                onClick={() => handleDeleteClick(params.row)}
              >
                <BiTrash />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <IconButton
            onClick={(e) => handleMenuClick(e, params)}
            aria-controls={openMenu ? params.row.id : undefined}
            aria-haspopup="true"
            aria-expanded={openMenu ? "true" : undefined}
          >
            <HiMenu />
          </IconButton>
        );
      },
    },
  ].filter((x) => (_Role === "dentist" ? x.field !== "operations" : x));

  const operationMenu = (params) => (
    <Menu
      sx={{ direction: "ltr" }}
      anchorEl={openMenu}
      keepMountede
      id="account-menu"
      open={activeItem === params}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            left: "50%",
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem
        onClick={() => {
          dispatch(Xray.getById(params.row.id));
        }}
        color="success"
      >
        <ListItemIcon>
          <BiEdit size={20} color="#0094D0" />
        </ListItemIcon>
        تعديل
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleDeleteClick(params.row);
        }}
      >
        <ListItemIcon>
          <BiTrash size={20} color="#D32F2F" />
        </ListItemIcon>
        حذف
      </MenuItem>
    </Menu>
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(Xray.getAll(_SearchBody));
    }, 500);
    return () => clearTimeout(timeout);
  }, [dispatch, _SearchBody]);

  useEffect(() => {
    dispatch(
      setSearchBody({
        search: search.name ?? "",
        xray_type_id: search.xray_type_id ?? "",
        start_date: search.start_date,
        end_date: search.end_date,
        skip: pageSize * currentPage,
        take: pageSize,
      })
    );
  }, [dispatch, search, pageSize, currentPage]);

  return (
    <Card>
      <Dialog
        open={openImageDialog}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        dir="rtl"
        onClose={() => {
          setOpenImageDialog(false);
        }}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
      >
        <DialogContent>
          <Typography
            mb={3}
            variant="h4"
            color={"purple"}
            gutterBottom
            component="div"
          >
            صورة الاشعة
          </Typography>
          <Divider />
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box
              component="img"
              src={imageDialogData}
              sx={{ width: "100%", padding: 2 }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      <CardContent>
        <Box>
          {activeItem && operationMenu(activeItem)}
          <ConfirmationDialog
            open={openConfirm}
            title="تاكيد"
            message="هل انت متاكد من حذف"
            name={dialogData.patient_name}
            confirmText="حذف"
            cancelText="الغاء"
            onConfirm={() => handleConfirmDelete()}
            onCancel={handleCancelDelete}
          />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={3}>
            <TextField
              size="small"
              value={search.name}
              onChange={(e) => {
                setSearch({
                  ...search,
                  name: e.target.value,
                });
              }}
              label="بحث عن اسم المراجع"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectXrayType
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  xray_type_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _XrayType?.filter((x) => x.id === search.xray_type_id)[0] ??
                null
              }
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <DateRangepicker
              startDate={search.start_date}
              endDate={search.end_date}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    start_date: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    end_date: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="الغاء الفلتر">
              <IconButton
                onClick={() => {
                  setSearch({
                    name: "",
                    xray_type_id: null,
                    start_date: dayjs().format("YYYY-MM-DD"),
                    end_date: dayjs().format("YYYY-MM-DD"),
                  });
                  setPageSize(15);
                  setCurrentPage(0);
                }}
              >
                <MdOutlineClear />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: "70vh", width: "100%" }}>
              <DataGrid
                sx={{
                  ".MuiDataGrid-cell:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-cell[data-field='attachment']:hover": {
                    cursor: "pointer",
                  },
                }}
                rows={_Xray.data}
                columns={columns}
                pageSize={pageSize}
                page={currentPage}
                rowCount={_Xray.total}
                loading={loading}
                rowHeight={100}
                pagination
                paginationMode="server"
                selectionModel={[]}
                onPageChange={(newPage) => setCurrentPage(newPage)}
                rowsPerPageOptions={[15, 25, 50, 100]}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize);
                }}
                components={{
                  LoadingOverlay: LinearProgress,
                }}
                onCellClick={(params) => {
                  handleCellClick(params);
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default XrayTable;
